import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DocumentService } from '@app/shared/services';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'onboarding-form-name-widget',
  templateUrl: './onboarding-form-name-widget.component.html',
  styleUrls: ['./onboarding-form-name-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingFormNameWidgetComponent implements OnInit, OnDestroy {
  @Input() data;
  @Input() currentuserId;
  @Input() insurance_attributes;
  @Input() form_name;
  subscription = new Subscription();
  status = '';
  stepOneCompleted = false;
  constructor(private documentService: DocumentService) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  saveForm() {
    this.subscription.add(
      this.documentService
        .saveFormNameInDb({
          form_name: this.form_name,
          id: this.data.vault_user_form_id,
          user_id: this.currentuserId,
        })
        .subscribe(
          (res) => {},
          (error) => {}
        )
    );
  }

  ngOnInit(): void {
    setTimeout(() => {
      // this will make the execution after the above boolean has changed
      eval(`var input = document.getElementById('text-giv');
      input.focus();
      input.select();`);
    }, 0);
  }
}
